var render = function render() {
  var _vm = this,
      _c = _vm._self._c;return _c('div', { staticClass: "app-container" }, [_c('el-menu', { staticClass: "el-menu-demo", attrs: { "default-active": _vm.activeIndex, "mode": "horizontal", "router": "" } }, [_c('el-menu-item', { attrs: { "index": "retain-capital" } }, [_vm._v("官网留资")]), _vm._v(" "), _c('el-menu-item', { attrs: { "index": "activity-clues" } }, [_vm._v("活动线索")]), _vm._v(" "), _c('el-menu-item', { attrs: { "index": "message" } }, [_vm._v("用户留言")])], 1), _vm._v(" "), _c('router-view')], 1);
};
var staticRenderFns = [];

export { render, staticRenderFns };